import { useMemo } from 'react'
import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { deleteFolder } from '../query-api'

interface UseDeleteFolderProps {
  onSuccess?: () => void
  onError?: () => void
}

export const useDeleteFolder = (props: UseDeleteFolderProps) => {
  const { onSuccess, onError } = props
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(deleteFolder, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(QueryKeys.DmsFolders)
      queryClient.removeQueries([QueryKeys.DmsFolderContents, variables.folderId])
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })

  return useMemo(() => ({ deleteFolder: mutate, isProcessing: isLoading }), [mutate, isLoading])
}
